import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSideCategoryMenuStore } from "@/components/SideSheets/store/useCategoryMenuStore";
import Icon from "@/components/icon/Icon";
import { ArrowDownOutlined, ArrowUp, Cart, Hamburger, Library, Sizes, Studio, User } from "@/components/icon/IconList";
import apiService from "@/lib/apiService/apiService";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { redirect } from "@/lib/next-utils";
import { LogoutCommand } from "@/modules/accounts/commands/logoutCommand";
import { GetLabByAuthorIdCommand } from "@/modules/lab/commands/getLabByAuthorIdCommand";
import { EBOOKS_UNIVERSITY_LANDING, HOME_PAGE, LIBRARIES_INDEX_PAGE, MYPAGE_PAGE, SHOP_CART_PAGE, SOLVOOK_WRITE_STUDIO, STUDIO_TITLE } from "@/settings/constant";
import { Dropdown } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSavedUserSourceStore } from "src/store/main";
import { isInWebview } from "src/utils/misc";
import { useTheme } from "styled-components";
import { LoginMenuWrapper, MenuHam, MypageMenu } from "./GNB.style";
import { utilItems_default } from "./categoryItems";
const LoginMenu = (param)=>{
    let { cartItemsCount  } = param;
    const { pathname  } = useRouter();
    const theme = useTheme();
    const authStore = useAuthStore();
    const [isAuthor, setIsAuthor] = useState(false);
    const [isMypageDropdown, setIsMypageDropdown] = useState(false);
    const [labName, setLabName] = useState(null);
    const { updateUserMeta  } = useSavedUserSourceStore((param)=>{
        let { updateUserMeta  } = param;
        return {
            updateUserMeta
        };
    });
    const { closeSideMenu , openMobileSideMenu  } = useSideCategoryMenuStore();
    const { logoutCommand , isUseFooter  } = useMemo(()=>({
            logoutCommand: new LogoutCommand(apiService),
            isUseFooter: !isInWebview()
        }), [
        apiService
    ]);
    const utilItems = useMemo(()=>[
            ...isAuthor ? [
                {
                    key: "3",
                    label: /*#__PURE__*/ _jsx(Link, {
                        onClick: ()=>mixpanelEvent("MyClicked", {
                                "Menu Category": "authorHome"
                            }),
                        href: "/@".concat(labName),
                        children: "나의 연구소"
                    })
                }
            ] : [],
            ...utilItems_default
        ], [
        isAuthor,
        labName,
        utilItems_default
    ]);
    //저자홈
    const getLabByAuthorIdCommand = useMemo(()=>new GetLabByAuthorIdCommand(apiService), [
        apiService
    ]);
    const { postProcessForKakao  } = useSignout();
    const onLogout = useCallback(async ()=>{
        if (authStore.user.providerId === "kakao") {
            postProcessForKakao();
        }
        authStore.logout();
        await logoutCommand.execute();
        redirect(HOME_PAGE);
    }, [
        authStore,
        logoutCommand,
        postProcessForKakao
    ]);
    const handleLogout = ()=>{
        updateUserMeta({
            mainSubject: null,
            job: null
        });
        closeSideMenu();
        onLogout();
    };
    const handleMenuClick = useCallback((e)=>{
        mixpanelEvent("GNB Button Clicked", {
            //mx-16 gnb 버튼 클릭 시
            "Button Name": "마이페이지"
        });
        if (e.key === "logout") {
            mixpanelEvent("GNB Button Clicked", {
                //mx-16 gnb 버튼 클릭 시
                "Button Name": "로그아웃"
            });
            handleLogout();
        }
    // handleDimClick()
    }, [
        onLogout
    ]);
    const fetchLabData = async ()=>{
        try {
            const response = await getLabByAuthorIdCommand.execute({
                author_id: authStore.user.id
            });
            setLabName(response.lab.lab_name);
            setIsAuthor(true);
        } catch (e) {}
    };
    //gnb가 또 공사가 될 예정일 수 있나 싶어서 분기를 쳐놨습니다..
    const isUniversityHome = useMemo(()=>{
        if (pathname.includes(EBOOKS_UNIVERSITY_LANDING)) {
            return true;
        }
        return false;
    }, [
        pathname
    ]);
    useEffect(()=>{
        var _authStore_user, _authStore_user_flags;
        if (authStore.isLoggedIn && (authStore === null || authStore === void 0 ? void 0 : (_authStore_user = authStore.user) === null || _authStore_user === void 0 ? void 0 : (_authStore_user_flags = _authStore_user.flags) === null || _authStore_user_flags === void 0 ? void 0 : _authStore_user_flags.is_use_lab)) {
            fetchLabData();
        } else setIsAuthor(false);
    }, [
        authStore.isLoggedIn,
        authStore.user
    ]);
    return /*#__PURE__*/ _jsxs(LoginMenuWrapper, {
        count: cartItemsCount,
        className: "gnb-login-menu",
        children: [
            authStore.isLoggedIn && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isUniversityHome && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Link, {
                                href: LIBRARIES_INDEX_PAGE,
                                onClick: ()=>{
                                    mixpanelEvent("GNB Button Clicked", {
                                        "Button Name": "자료 보관함"
                                    });
                                },
                                passHref: true,
                                className: "link-to-libraries",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Library,
                                        size: Sizes.medium,
                                        color: theme.new.colors.sol_gray_700
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "자료 보관함"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Link, {
                                onClick: ()=>{
                                    mixpanelEvent("GNB Button Clicked", {
                                        "Button Name": "스튜디오"
                                    });
                                },
                                className: "studio-link",
                                href: SOLVOOK_WRITE_STUDIO,
                                passHref: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Studio,
                                        size: Sizes.medium,
                                        color: theme.new.colors.sol_gray_700
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: STUDIO_TITLE
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Link, {
                        onClick: ()=>{
                            mixpanelEvent("GNB Button Clicked", {
                                //mx-16 gnb 버튼 클릭 시
                                "Button Name": "장바구니"
                            });
                        },
                        className: "cart-link",
                        href: SHOP_CART_PAGE,
                        passHref: true,
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Cart,
                                size: Sizes.medium,
                                color: theme.new.colors.sol_gray_700
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "장바구니"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(MypageMenu, {
                        children: /*#__PURE__*/ _jsx(Dropdown, {
                            onOpenChange: (open)=>setIsMypageDropdown(open),
                            trigger: [
                                "click"
                            ],
                            menu: {
                                items: utilItems,
                                onClick: handleMenuClick
                            },
                            overlayClassName: "dropdown util_dropdown",
                            placement: "bottom",
                            children: /*#__PURE__*/ _jsx(Link, {
                                href: MYPAGE_PAGE,
                                passHref: true,
                                onClick: (e)=>{
                                    e.preventDefault();
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "stack-row",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "stack-centered",
                                            children: [
                                                /*#__PURE__*/ _jsx(Icon, {
                                                    icon: User,
                                                    size: Sizes.medium,
                                                    color: theme.new.colors.sol_gray_800
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    children: "마이페이지"
                                                })
                                            ]
                                        }),
                                        isMypageDropdown ? /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowUp,
                                            size: Sizes.small
                                        }) : /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowDownOutlined,
                                            size: Sizes.small
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuHam, {
                children: /*#__PURE__*/ _jsxs("button", {
                    onClick: ()=>openMobileSideMenu(),
                    className: "mobile-menu-icon",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Hamburger,
                            size: Sizes.medium,
                            color: theme.new.colors.sol_gray_900
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: "메뉴"
                        })
                    ]
                })
            })
        ]
    });
};
export default LoginMenu;
export const useSignout = ()=>{
    const postProcessForKakao = useCallback(()=>{
        const searchParams = new URLSearchParams();
        searchParams.set("client_id", process.env.NEXT_PUBLIC_KAKAO_REST_API_KEY);
        searchParams.set("logout_redirect_uri", document.location.origin.concat("/login/kakao-logout"));
        window.open("https://kauth.kakao.com/oauth/logout?".concat(searchParams.toString()), "solvook-kakao-logout", "width=500, height=700, scrollbars=no, resizable=no");
    }, []);
    return {
        postProcessForKakao
    };
};
